import { ButtonTypes } from '../enums/button-types.enum';

export const BUTTON_TYPE_DESCRIPTIONS = {
  [ButtonTypes.None]: 'Nothing is assigned to this button.',
  [ButtonTypes.Private]: 'Add an additional line for your extension on your phone.',
  [ButtonTypes.Extension]:
    'Select any extension in your phone system to make a direct call to. Once an extension is saved to this button, you will also be able to see when this extension is on a phone call.',
  [ButtonTypes.Park]: 'Park a call on each Park Orbit button.',
  [ButtonTypes.Login]: 'Login or log out of the selected queue.',
  [ButtonTypes.Flag]: 'Manually activate the selected service flag.',
  [ButtonTypes.Speed]: 'Directly make a call to any 10 digit phone number or star code.',
  [ButtonTypes.HuntGroup]: 'Directly make a call to any Hunt Group in your phone system.',
  [ButtonTypes.AgentGroup]: 'Directly make a call to any Agent Group in your phone system.',
};
